import React, { useRef } from 'react';
import MessageContainer from './MessageContainer';
import MessageAuthor from './MessageAuthor';
import { Stack } from '@fluentui/react';
import Citation from './Citation';
import 'katex/dist/katex.min.css';
import AIMessageParser from './AIMessageParser';
import ResponseAction from './ResponseAction';
import IMessage from '../../../models/IMessage';
import { MessageType } from '../../../enums/MessageType';


export const MessageComponent: React.FC<IMessage> = (MessageProps:IMessage) => {
    const { isUser, author, content, citations, messageType } = MessageProps;
    const messageRef = useRef<HTMLDivElement | null>(null);

    return (
        <MessageContainer isUser={isUser} >
            {!isUser && author && <MessageAuthor author={author} isUser={isUser} />}
            <Stack grow={95}>
                <AIMessageParser message={content} messageRef={messageRef}></AIMessageParser>
                {citations && citations.length > 0 && <Citation links={citations} />}
                {!isUser && messageType === MessageType.Regular && <ResponseAction messageRef={messageRef} MessageProps={MessageProps} />}
            </Stack>
            {isUser && author && <MessageAuthor author={author} isUser={isUser} />}
        </MessageContainer>

    );
};

export default MessageComponent;
